import React from "react";
import System from "../services/SystemServices";

const LoginPage = () => {
  function CallLoginApi(event) {
    event.preventDefault();
    //console.log("what ami sending:", event);
    return System.Login(event)
      .then((res) => {
        if (res && res.result === "true") {
          window.location.reload();
        } else {
          alert("Нууц үг буруу байна");
        }
      })
      .catch((err) => alert({ err }));
  }
  return (
    <div className="flex items-center justify-center h-screen w-full px-5 sm:px-0 flex-col">
      <div className="w-full flex justify-center mb-14">
        <img src="/new_logo.png" className="h-20" alt="Ddish Logo" />
      </div>
      <div className="flex bg-white rounded-lg shadow-lg border overflow-hidden max-w-sm lg:max-w-l w-full">
        <div className="w-full p-8 ">
          <form
            className="d-flex flex-column"
            style={{ gap: "10px" }}
            onSubmit={CallLoginApi}
          >
            <div className="mt-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Нэвтрэх нэр 用户名
              </label>
              <input
                className="text-gray-700 border border-gray-300 rounded py-2 px-4 block w-full focus:outline-2 focus:outline-blue-700"
                type="text"
                name="username"
                required
              />
            </div>
            <div className="mt-4 flex flex-col justify-between">
              <div className="flex justify-between">
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  Нууц үг
                </label>
              </div>
              <input
                className="text-gray-700 border border-gray-300 rounded py-2 px-4 block w-full focus:outline-2 focus:outline-blue-700"
                type="password"
                name="password"
              />
            </div>
            <div className="mt-8">
              <button
                className="bg-blue-700 text-white font-bold py-2 px-4 w-full rounded hover:bg-blue-600"
                type="submit"
              >
                Нэвтрэх 登
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default LoginPage;
